// extracted by mini-css-extract-plugin
export var arrows = "_2k-5";
export var decrementer = "_2k-9";
export var disabled = "_2k-3";
export var error = "_2k-1";
export var hiddenText = "_2k-a";
export var incrementer = "_2k-8";
export var input = "_2k-7";
export var inputWrapper = "_2k-0";
export var leadingIcon = "_2k-b";
export var readonly = "_2k-2";
export var regular = "_2k-6";
export var small = "_2k-4";